import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {HttpClient} from '@angular/common/http';
import {ItemSummaryItemSummaryService} from './item-summary-item-summary.service';
import {Asset, AssetPhoto} from '../domain/item';
import {appConfig} from '../app.config';
import {Contract} from '../domain/contract';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryAssetSummaryService extends ItemSummaryItemSummaryService {

  getAssetUrl = '/api/asset/:assetId/details';
  private readonly saveAssetInfoUrl = '/api/asset/:assetId/assetinformation';
  private readonly saveAssetSaleInfoUrl = '/api/asset/:assetId/assetSaleInformation';

  constructor(private http: HttpClient) {
    super();
  }

  public getItem(assetId: number): void {
    let url = this.getAssetUrl;
    url = url.replace(':assetId', assetId.toString());
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAsset', {}))
      )
      .subscribe(response => {
        this.data.asset = Object.assign(new Asset(), response);
        const asset = Asset.constructFromObjectJson(response);
        if (asset) {
          this.assetServiceCallback.next(asset);
        }
      });
  }

  public updateAssetInformation(asset: Asset): Observable<any> {
    const url = this.saveAssetInfoUrl.replace(':assetId', String(asset.assetId));
    return this.http.post<any>(url, asset, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );
  }


  public updateSaleInformation(asset: Asset): Observable<any> {
    const url = this.saveAssetSaleInfoUrl.replace(':assetId', String(asset.assetId));
    return this.http.post<any>(url, asset, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );
  }

  public getContractInfo(itemId: number): Observable<Contract> {
    return undefined;
  }

  public getItemPhotos(itemId: number): Observable<AssetPhoto> {
    const url = `/api/assets/${itemId}/photos`;
    return this.http.get<AssetPhoto>(url, appConfig.httpOptions)
      .pipe(
        tap((assetPhotoJson) => AssetPhoto.fromJson(assetPhotoJson)),
        catchError(HttpRequestErrorHandler.handleError('getItemPhotos', {}))
      );
  }
}
